
import Vue from 'vue';
import Analytics from '@/helpers/analytics';
import { Modal, Button } from '@descomplica/vue-components';
import { isMobileDevice } from '../../../helpers/mobile';
import { EVENT_LABELS } from '@/helpers/analytics/labels';

export default Vue.extend({
  components: {
    Modal,
    Button,
  },
  props: {
    active: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    modalBorderRadius(): number {
      return this.isMobileDevice ? 0 : 32;
    },
    isMobileDevice(): boolean {
      return isMobileDevice();
    },
  },
  methods: {
    closeModal(): void {
      Analytics.trackEvent(EVENT_LABELS.buttonClicked, {
        action: 'close',
        in_soon_helper_modal: true,
      });
      this.updateActive(false);
    },
    updateActive(active: boolean): void {
      this.$emit('update:active', active);
    },
  },
});
